import getTextWidth from "./getTextWidth";

export default function truncateText(input, textWidthLimit) {
  if (getTextWidth(input) <= textWidthLimit) return input;
  for (let i = 0; i < input.length; i++) {
    input = input.slice(0, -1);
    if (getTextWidth(input) <= textWidthLimit) {
      return `${input}...`;
    }
  }
}
